import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7288e249"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder", "aria-label"]
const _hoisted_2 = ["placeholder", "aria-label"]
const _hoisted_3 = ["title"]

import { ref } from '@vue/reactivity';
import Message from 'primevue/message';
import domainRepository from '@/api/domainRepository';
import FormControlSelect from '@/components/general/FormControl/Select.vue';
import { onMounted } from 'vue';
import { domainStore } from '@/store/domain-store';
import { add } from 'ol/coordinate';
import { Form } from 'vee-validate';


export default /*#__PURE__*/_defineComponent({
  props: {
  usesStreet: {
    type: Boolean,
    default: false,
    required: false,
  },
  bmsContext: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ['addressCoordinatesReceived'],
  setup(__props, { emit }) {

const props = __props





const streetsName = ref<{ id: number; text: string }[]>([]);
const messageInformation = ref<{ text: string; severity: 'error' | 'warn' }>({ text: '', severity: 'warn' });
const address = ref();
const housenum = ref('');
const toggleMessage = ref(false);
//functions
function selectedElem(event: any) {
  address.value = streetsName.value.find(element => element.id == event.value)?.text;
}
function searchAddress() {
  if (props.usesStreet) {
    address.value = address.value.replace(',', ' ' + housenum.value + ', ');
  }
  domainRepository.searchAddress(address.value).then((response: any) => {
    const apiData = response.data.data;
    let emitItem;
    let locationData;
    let queryAddress;

    //check if we get results
    if (apiData.status != 'ZERO_RESULTS') {
      queryAddress = apiData.results[0].formatted_address;

      //check if results are approximated or not

      if (apiData.is_approximate) {
        messageInformation.value = {
          severity: 'warn',
          text: domainStore.translate('general.map.address-search.message.approximate', { address: queryAddress }),

          // 'Die von Ihnen eingegebene Adresse konnte möglicherweise nicht gefunden werden.' +
          // ' Die Meldung wird an der Adresse ' +
          // queryAddress +
          // ' platziert.' +
          // ' Zur Änderung der Position geben Sie bitte eine andere Adresse über das Suchfeld ein,' +
          // ' oder setzen Sie die Markerposition manuell über die Karte.',
        };

        toggleMessage.value = true;
      }
      //assign correct values and emit if its correct
      locationData = apiData.results[0].geometry.location;
      emitItem = { query: address.value, lon: locationData.lng, lat: locationData.lat, zoom: 18 };
      emit('addressCoordinatesReceived', emitItem);
    } else {
      messageInformation.value = {
        severity: 'error',
        text: domainStore.translate('general.map.address-search.message.not-found'),
      };
      toggleMessage.value = true;
    }
    address.value = '';
  });
}
onMounted(() => {
  if (props.usesStreet) {
    const domainid = domainStore.getState().domainid;
    if (domainid) {
      domainRepository.getStreets(domainid).then(res => {
        streetsName.value = res.streets.map((element: any) => {
          return { id: element.id, text: element.street };
        });
      });
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["wdw-map-search-address search-wrapper-elem d-flex justify-content-end", { 'bms-context': __props.bmsContext }])
    }, [
      (__props.usesStreet)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(FormControlSelect, {
              name: "streets",
              class: "streets",
              options: streetsName.value,
              onSelected: _cache[0] || (_cache[0] = ($event: any) => (selectedElem($event)))
            }, null, 8, ["options"]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((housenum).value = $event)),
              class: "house-number form-control me-2",
              placeholder: _unref(domainStore).translate('general.map.address-search.house-number'),
              "aria-label": _unref(domainStore).translate('general.map.address-search.search'),
              "aria-describedby": "search-button"
            }, null, 8, _hoisted_1), [
              [_vModelText, housenum.value]
            ])
          ], 64))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "text",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address).value = $event)),
            onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchAddress()), ["enter"])),
            class: "search-input form-control me-2",
            placeholder: 
          __props.bmsContext
            ? _unref(domainStore).translate('general.map.address-search.address-placeholder')
            : _unref(domainStore).translate('general.map.address-search.search')
        ,
            "aria-label": _unref(domainStore).translate('general.map.address-search.search'),
            "aria-describedby": "search-button"
          }, null, 40, _hoisted_2)), [
            [_vModelText, address.value]
          ]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (searchAddress())),
        class: "btn btn-primary btn-search-button",
        id: "search-button",
        title: _unref(domainStore).translate('general.map.address-search.search')
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "search" })
      ], 8, _hoisted_3)
    ], 2),
    _withDirectives(_createVNode(_unref(Message), {
      class: "popup-message wdw-map-search-address",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleMessage.value = false)),
      severity: messageInformation.value.severity
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(messageInformation.value.text), 1)
      ]),
      _: 1
    }, 8, ["severity"]), [
      [_vShow, toggleMessage.value]
    ])
  ], 64))
}
}

})